import React from "react";
import StudentTestimonialFormPage from "../components/student-testimonials/StudentTestimonialFormPage";

const StudentTestimonialCreate = () => <StudentTestimonialFormPage mode="create" />;

export default StudentTestimonialCreate;
